// extracted by mini-css-extract-plugin
export default {"utilities":"utilities_utilities__rloHI"};